import { z } from 'zod/v4';

const MetricsQueryParamsRuntype = z.record(z.string(), z.union([z.string(), z.number(), z.boolean()]));

/** Input for `monitoring.metrics.sqlQuery`. */
export const MetricsQueryInputRuntype = z.object({
    sql: z.string(),
    params: MetricsQueryParamsRuntype.optional(),
});
